// extracted by mini-css-extract-plugin
export default {"input":"style_input__2872d","textArea":"style_textArea__Pgewd","small":"style_small__dsGDD","large":"style_large__EQm+x"};